var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamMembersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1C3.5 0.447715 3.94772 0 4.5 0H6.5C7.05228 0 7.5 0.447715 7.5 1V3.5C7.5 4.05228 7.05228 4.5 6.5 4.5H4.5C3.94772 4.5 3.5 4.05228 3.5 3.5V1ZM6.5 1H4.5V3.5H6.5V1ZM14 4C14 3.44772 14.4477 3 15 3H17C17.5523 3 18 3.44772 18 4V6.5C18 7.05228 17.5523 7.5 17 7.5H15C14.4477 7.5 14 7.05228 14 6.5V4ZM17 4H15V6.5H17V4ZM0.5 8C0.5 6.89543 1.39543 6 2.5 6H8.5C9.60457 6 10.5 6.89543 10.5 8V11.75C10.5 12.0648 10.3518 12.3611 10.1 12.55L8.5 13.75V17C8.5 17.5523 8.05228 18 7.5 18H3.5C2.94772 18 2.5 17.5523 2.5 17V13.75L0.9 12.55C0.648194 12.3611 0.5 12.0648 0.5 11.75V8ZM2.5 12.5V9H3.5V17H7.5V9H8.5V12.5L9.5 11.75V8C9.5 7.44772 9.05229 7 8.5 7H2.5C1.94772 7 1.5 7.44772 1.5 8V11.75L2.5 12.5ZM12.5 11C12.5 9.89543 13.3954 9 14.5 9H17.5C18.6046 9 19.5 9.89543 19.5 11V13.2929C19.5 13.5581 19.3946 13.8125 19.2071 14L18.5 14.7071V17C18.5 17.5523 18.0523 18 17.5 18H14.5C13.9477 18 13.5 17.5523 13.5 17V14.7071L12.7929 14C12.6054 13.8125 12.5 13.5581 12.5 13.2929V11ZM14.5 10C13.9477 10 13.5 10.4477 13.5 11V13.2929L14.2071 14C14.3946 14.1875 14.5 14.4419 14.5 14.7071V17H17.5V14.7071C17.5 14.4419 17.6054 14.1875 17.7929 14L18.5 13.2929V11C18.5 10.4477 18.0523 10 17.5 10H14.5Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembersIcon);
export default __webpack_public_path__ + "static/media/TeamMembersIcon.4a7c8cbfc6cda5d70d36cd2f82e827bc.svg";
export { ForwardRef as ReactComponent };